/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
export var FormFieldMappingStatus;
(function (FormFieldMappingStatus) {
    FormFieldMappingStatus[FormFieldMappingStatus["Success"] = 0] = "Success";
    FormFieldMappingStatus[FormFieldMappingStatus["NotFound"] = 1] = "NotFound";
    FormFieldMappingStatus[FormFieldMappingStatus["Error"] = 2] = "Error";
})(FormFieldMappingStatus || (FormFieldMappingStatus = {}));
